export interface CCTipoDeCuenta {
    codigoTipoCuenta: any;
    descripcion: any;
    creditoDebito : any;
}

export class CCTipoDeCuenta implements CCTipoDeCuenta {
    constructor(init?: CCTiposDeCuentasFormValues) {
        Object.assign(this, init);
    }
}

export class CCTiposDeCuentasFormValues {
    codigoTipoCuenta: number = 0;
    descripcion: string = "";
    creditoDebito: string ="";

    constructor(CCTipoDeCuenta?: CCTiposDeCuentasFormValues) {
        if (CCTipoDeCuenta) {
            this.codigoTipoCuenta = CCTipoDeCuenta.codigoTipoCuenta;
            this.descripcion = CCTipoDeCuenta.descripcion || '';
            this.creditoDebito = CCTipoDeCuenta.creditoDebito || '';
        }

    }
}